import React from "react";

/** Lightweight fallback while lazy route chunks load */
export default function RouteFallback() {
  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center bg-zinc-50 px-6" role="status" aria-live="polite" aria-busy="true">
      <div
        className="h-9 w-9 animate-spin rounded-full border-[3px] border-primary-500/35 border-t-primary-600"
        aria-hidden
      />
      <p className="mt-4 text-xs font-medium text-neutral-500">Loading…</p>
    </div>
  );
}
